<template>
    <div class="main">
        <c-panel title="INTEGRAÇÃO COM A SED — Secretaria Digital do Estado de São Paulo" titleIcon="fas fa-cloud">

            <!-- SITUAÇÃO -->
            <div class="sed-status" :class="painel.situacao.disponivel ? 'ok' : 'erro'">
                <i :class="painel.situacao.disponivel ? 'el-icon-success' : 'el-icon-warning'"></i>
                <strong>{{ painel.situacao.disponivel ? 'SED disponível' : 'SED fora do ar' }}</strong>
                <span class="sep">·</span>
                <span>Ambiente: <strong>{{ painel.ambiente === 'producao' ? 'Produção' : 'Homologação' }}</strong></span>
                <span class="sep">·</span>
                <span>Última consulta com sucesso: {{ painel.situacao.ultima_ok ? $moment(painel.situacao.ultima_ok).format('DD/MM HH:mm') : '—' }}</span>
                <span class="sep">·</span>
                <span>Erros na última hora: {{ Math.round((painel.situacao.taxa_erro_1h || 0) * 100) }}%</span>
                <el-tag v-if="!painel.habilitada" size="mini" type="info" style="margin-left: 10px;">Envio à SED desligado — somente leitura</el-tag>
                <el-button @click="carregar" size="mini" plain style="float: right;" :loading="carregando">
                    <i class="el-icon-refresh"></i> Atualizar
                </el-button>
            </div>

            <!-- CONTADORES -->
            <el-row :gutter="12" class="sed-kpis">
                <el-col :xs="12" :sm="8" :md="4"><div class="kpi" :class="{ alerta: painel.contadores.prioridade_alta > 0 }"><div class="v">{{ painel.contadores.prioridade_alta }}</div><div class="l">divergências de prioridade alta</div></div></el-col>
                <el-col :xs="12" :sm="8" :md="4"><div class="kpi"><div class="v">{{ painel.contadores.divergencias_abertas }}</div><div class="l">divergências abertas</div></div></el-col>
                <el-col :xs="12" :sm="8" :md="4"><div class="kpi"><div class="v">{{ painel.contadores.alunos_nao_sincronizados }}</div><div class="l">alunos com alteração não enviada</div></div></el-col>
                <el-col :xs="12" :sm="8" :md="4"><div class="kpi"><div class="v">{{ painel.contadores.operacoes_a_concluir }}</div><div class="l">operações a concluir</div></div></el-col>
                <el-col :xs="12" :sm="8" :md="4"><div class="kpi"><div class="v">{{ painel.contadores.turmas }}</div><div class="l">turmas vinculadas</div></div></el-col>
                <el-col :xs="12" :sm="8" :md="4"><div class="kpi"><div class="v">{{ painel.contadores.matriculas_ativas }}</div><div class="l">matrículas ativas vinculadas</div></div></el-col>
            </el-row>

            <p v-if="painel.ultima_execucao" class="sed-ultima">
                Última comparação com a SED: <strong>{{ $moment(painel.ultima_execucao.iniciada_em).format('DD/MM/YYYY HH:mm') }}</strong>
                — {{ rotuloStatus(painel.ultima_execucao.status) }}
                ({{ painel.ultima_execucao.divergencias_novas }} nova(s), {{ painel.ultima_execucao.divergencias_resolvidas }} resolvida(s), {{ painel.ultima_execucao.autocorrecoes }} atualização(ões) automática(s))
            </p>

            <el-tabs v-model="aba">

                <!-- DIVERGÊNCIAS -->
                <el-tab-pane label="Divergências" name="divergencias">
                    <el-row :gutter="10" style="margin-bottom: 10px;">
                        <el-col :xs="24" :sm="9">
                            <el-select v-model="filtro.instituicao_id" placeholder="Todas as escolas" clearable filterable size="small" style="width: 100%;" @change="buscarDivergencias(1)">
                                <el-option v-for="e in painel.escolas" :key="e.id" :label="e.nome" :value="e.id"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="12" :sm="8">
                            <el-select v-model="filtro.tipo" placeholder="Todos os tipos" clearable size="small" style="width: 100%;" @change="buscarDivergencias(1)">
                                <el-option v-for="(t, k) in tipos" :key="k" :label="t.rotulo" :value="k"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="12" :sm="7">
                            <el-select v-model="filtro.status" size="small" style="width: 100%;" @change="buscarDivergencias(1)">
                                <el-option label="Abertas" value="ABERTA"></el-option>
                                <el-option label="Ignoradas" value="IGNORADA"></el-option>
                                <el-option label="Resolvidas automaticamente" value="RESOLVIDA_AUTO"></el-option>
                                <el-option label="Resolvidas por usuário" value="RESOLVIDA_USUARIO"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-table :data="divergencias.data" v-loading="carregandoDivergencias" size="small" empty-text="Nenhuma divergência — o SMGE e a SED estão iguais.">
                        <el-table-column label="Escola" prop="instituicao" min-width="170"></el-table-column>
                        <el-table-column label="Tipo" min-width="170">
                            <template slot-scope="s">
                                <el-tag size="mini" :type="corPrioridade(s.row.prioridade)">{{ tipos[s.row.tipo] ? tipos[s.row.tipo].rotulo : s.row.tipo }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="Detalhe" min-width="320">
                            <template slot-scope="s">{{ descrever(s.row) }}</template>
                        </el-table-column>
                        <el-table-column label="Desde" width="90">
                            <template slot-scope="s">{{ $moment(s.row.primeira_deteccao_em).format('DD/MM/YY') }}</template>
                        </el-table-column>
                        <el-table-column label="" width="300" align="right">
                            <template slot-scope="s">
                                <el-button v-if="s.row.status === 'ABERTA' && aceitaveis.includes(s.row.tipo)" size="mini" type="primary" plain :loading="resolvendo === s.row.id" @click="confirmarAcao(s.row, 'ACEITAR_SED')">Usar o que está na SED</el-button>
                                <el-button v-if="s.row.status === 'ABERTA' && s.row.tipo === 'ALUNO_DADOS_DIFERENTES'" size="mini" type="primary" plain :loading="resolvendo === s.row.id" @click="confirmarAcao(s.row, 'USAR_FICHA_SED')">Usar dados da SED</el-button>
                                <el-button v-if="s.row.status === 'ABERTA' && s.row.tipo === 'ALUNO_DADOS_DIFERENTES'" size="mini" plain :loading="resolvendo === s.row.id" @click="confirmarAcao(s.row, 'REENVIAR_FICHA_SMGE')">Enviar dados do SMGE</el-button>
                                <el-button v-if="s.row.status === 'ABERTA' && encerraveis.includes(s.row.tipo)" size="mini" type="warning" plain :loading="resolvendo === s.row.id" @click="confirmarAcao(s.row, 'ENCERRAR_NO_SMGE')">Registrar transferência</el-button>
                                <el-button v-if="s.row.status === 'ABERTA'" size="mini" plain @click="resolver(s.row, 'IGNORAR')">Ignorar</el-button>
                                <el-button v-if="s.row.status === 'IGNORADA'" size="mini" plain @click="resolver(s.row, 'REABRIR')">Reabrir</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-pagination v-if="divergencias.total > divergencias.per_page" style="margin-top: 10px; text-align: right;"
                        layout="prev, pager, next" :total="divergencias.total" :page-size="divergencias.per_page"
                        :current-page="divergencias.current_page" @current-change="buscarDivergencias"></el-pagination>
                </el-tab-pane>

                <!-- ESCOLAS -->
                <el-tab-pane label="Escolas" name="escolas">
                    <el-table :data="painel.escolas" size="small">
                        <el-table-column label="Escola" prop="nome" min-width="260"></el-table-column>
                        <el-table-column label="Código na SED (CIE)" prop="codigo_sed" width="150"></el-table-column>
                        <el-table-column label="Unidade" prop="sed_cod_unidade" width="100"></el-table-column>
                        <el-table-column label="Situação" width="160">
                            <template slot-scope="s">
                                <el-tag size="mini" :type="s.row.codigo_sed ? 'success' : 'info'">{{ s.row.codigo_sed ? 'Vinculada à SED' : 'Sem código' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="Última comparação" width="150">
                            <template slot-scope="s">{{ s.row.sed_conciliado_em ? $moment(s.row.sed_conciliado_em).format('DD/MM/YY HH:mm') : '—' }}</template>
                        </el-table-column>
                        <el-table-column label="" width="150" align="right">
                            <template slot-scope="s">
                                <el-button size="mini" type="primary" plain :loading="conciliando === s.row.id" @click="conciliar(s.row)">Comparar agora</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

                <!-- CONFIGURAÇÃO (perfis de rede) -->
                <el-tab-pane v-if="podeConfigurar" label="Configuração" name="configuracao">

                    <div class="sed-status" :class="cfg.habilitada ? 'ok' : ''" style="margin-bottom: 16px;">
                        <strong>Envio à SED:</strong>
                        <el-switch :value="cfg.habilitada" @change="habilitar" active-text="ligado" inactive-text="desligado" style="margin-left: 10px;"></el-switch>
                        <span class="sep">·</span>
                        <span v-if="!cfg.tem_credencial" style="color: #f56c6c;">credencial da SED não configurada no servidor</span>
                        <span v-else-if="cfg.escrita_bloqueada" style="color: #e6a23c;">este servidor não é de produção: a SED de produção aceita só consultas daqui</span>
                        <span v-else>com o envio ligado, cada escola marcada abaixo grava primeiro na SED e depois no SMGE</span>
                    </div>

                    <h4 class="sed-h">Escolas</h4>
                    <el-table :data="cfg.escolas" size="small" max-height="360">
                        <el-table-column label="Instituição" prop="nome" min-width="240"></el-table-column>
                        <el-table-column label="Código na SED (CIE)" width="160">
                            <template slot-scope="s"><el-input v-model="s.row.codigo_sed" size="mini" @change="salvarEscola(s.row)"></el-input></template>
                        </el-table-column>
                        <el-table-column label="Unidade" width="130">
                            <template slot-scope="s"><el-input v-model="s.row.sed_cod_unidade" size="mini" @change="salvarEscola(s.row)"></el-input></template>
                        </el-table-column>
                    </el-table>
                    <p class="sed-ultima" style="margin-top: 6px;">Escola sem código fica fora da integração. O envio à SED é ligado para todas as escolas de uma vez, na aba Configuração.</p>

                    <h4 class="sed-h">Cursos — correspondência com a SED</h4>
                    <el-table :data="cfg.cursos" size="small" max-height="320">
                        <el-table-column label="Curso no SMGE" prop="nome" min-width="240"></el-table-column>
                        <el-table-column label="Tipo de ensino (cód. SED)" width="190">
                            <template slot-scope="s"><el-input v-model="s.row.sed_cod_tipo_ensino" size="mini" placeholder="ex.: 14" @change="salvarCurso(s.row)"></el-input></template>
                        </el-table-column>
                        <el-table-column label="Série / ano (cód. SED)" width="190">
                            <template slot-scope="s"><el-input v-model="s.row.sed_cod_serie_ano" size="mini" placeholder="vazio = nível na turma" @change="salvarCurso(s.row)"></el-input></template>
                        </el-table-column>
                    </el-table>
                    <p class="sed-ultima" style="margin-top: 6px;">Curso sem correspondência cria turma só no SMGE. Códigos: 6 = Educação Infantil (4 Berçário 1, 5 Berçário 2, 6 Maternal 1, 7 Maternal 2, 1 e 2 Pré-escola), 14 = Fundamental de 9 anos (1 a 9), 3 e 4 = EJA, 26 = Complementação, 32 = AEE; série 0 = multisseriada.</p>

                    <h4 class="sed-h">Chamadas à SED
                        <el-radio-group v-model="log.somente" size="mini" style="margin-left: 12px;" @change="buscarLog(1)">
                            <el-radio-button label="">Todas</el-radio-button><el-radio-button label="escritas">Envios</el-radio-button><el-radio-button label="erros">Erros</el-radio-button>
                        </el-radio-group>
                        <el-input v-model="log.processo_id" size="mini" placeholder="protocolo" clearable style="width: 160px; margin-left: 8px;" @change="buscarLog(1)"></el-input>
                    </h4>
                    <el-table :data="log.dados.data" size="small" v-loading="log.carregando">
                        <el-table-column label="Quando" width="130"><template slot-scope="s">{{ $moment(s.row.created_at).format('DD/MM HH:mm:ss') }}</template></el-table-column>
                        <el-table-column label="Ambiente" prop="ambiente" width="110"></el-table-column>
                        <el-table-column label="" prop="metodo" width="60"></el-table-column>
                        <el-table-column label="Serviço" prop="servico" min-width="230"></el-table-column>
                        <el-table-column label="HTTP" prop="http_status" width="65"></el-table-column>
                        <el-table-column label="Protocolo" prop="processo_id" width="125"></el-table-column>
                        <el-table-column label="Erro" prop="erro" min-width="220" show-overflow-tooltip></el-table-column>
                        <el-table-column label="ms" prop="duracao_ms" width="70" align="right"></el-table-column>
                    </el-table>
                    <el-pagination v-if="log.dados.total > log.dados.per_page" style="margin-top: 10px; text-align: right;" layout="prev, pager, next"
                        :total="log.dados.total" :page-size="log.dados.per_page" :current-page="log.dados.current_page" @current-change="buscarLog"></el-pagination>
                </el-tab-pane>

            </el-tabs>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        aba: 'divergencias',
        carregando: false,
        carregandoDivergencias: false,
        conciliando: null,
        resolvendo: null,
        // Ações por tipo (as mesmas listas do SedPainelController)
        aceitaveis: ['TURMA_SO_NA_SED', 'MATRICULA_SO_NA_SED', 'ALUNO_SO_NA_SED', 'SITUACAO_DIFERENTE', 'CLASSE_DIFERENTE', 'TURMA_DADOS_DIFERENTES'],
        encerraveis: ['ALUNO_EM_OUTRA_ESCOLA', 'MATRICULA_SO_NO_SMGE'],
        painel: {
            habilitada: false,
            ambiente: '',
            situacao: { disponivel: true, ultima_ok: null, taxa_erro_1h: 0 },
            escolas: [],
            contadores: { divergencias_abertas: 0, prioridade_alta: 0, alunos_nao_sincronizados: 0, operacoes_a_concluir: 0, turmas: 0, matriculas_ativas: 0 },
            ultima_execucao: null
        },
        cfg: { habilitada: false, tem_credencial: true, escrita_bloqueada: false, escolas: [], cursos: [] },
        log: { somente: '', processo_id: '', carregando: false, dados: { data: [], total: 0, per_page: 30, current_page: 1 } },
        filtro: { instituicao_id: null, tipo: null, status: 'ABERTA' },
        divergencias: { data: [], total: 0, per_page: 30, current_page: 1 },
        // Rótulos dos tipos de divergência (specs_sed/09 §4.1)
        tipos: {
            ALUNO_FALECIDO_NA_SED:  { rotulo: 'Aluno consta como falecido na SED' },
            ALUNO_EM_OUTRA_ESCOLA:  { rotulo: 'Aluno em outra escola' },
            ALUNO_DADOS_DIFERENTES: { rotulo: 'Dados do aluno diferentes' },
            SITUACAO_DIFERENTE:     { rotulo: 'Situação diferente' },
            CLASSE_DIFERENTE:       { rotulo: 'Aluno em outra turma na SED' },
            MATRICULA_SO_NO_SMGE:   { rotulo: 'Matrícula só no SMGE' },
            MATRICULA_SO_NA_SED:    { rotulo: 'Matrícula só na SED' },
            ALUNO_SO_NA_SED:        { rotulo: 'Aluno só na SED' },
            MATRICULA_SEM_VINCULO:  { rotulo: 'Aluno sem RA' },
            TURMA_SO_NO_SMGE:       { rotulo: 'Turma só no SMGE' },
            TURMA_SO_NA_SED:        { rotulo: 'Turma só na SED' },
            TURMA_SEM_VINCULO:      { rotulo: 'Turma sem vínculo com a SED' },
            TURMA_DADOS_DIFERENTES: { rotulo: 'Dados da turma diferentes' },
            SED_INCONSISTENTE:      { rotulo: 'Inconsistência na SED' }
        }
    }),
    computed: {
        // Mesmos perfis de rede do backend (config sed.perfis_rede).
        podeConfigurar () { return [4, 5, 6].includes(Number(this.$store.state.user.tipo)) }
    },
    watch: {
        aba (v) { if (v === 'configuracao') { this.carregarConfiguracao(); this.buscarLog(1) } }
    },
    mounted () { this.carregar() },
    methods: {
        url (caminho) { return `${this.$store.state.config.baseUrlApi}/api/sed/${caminho}` },

        carregar () {
            this.carregando = true
            this.$axios.get(this.url('painel'), this.$store.getters.getHeaderAuth).then(r => {
                this.painel = r.data
                this.buscarDivergencias(1)
            }).catch(e => this.$store.commit('throwException', e)).finally(() => { this.carregando = false })
        },

        buscarDivergencias (pagina) {
            this.carregandoDivergencias = true
            const params = Object.assign({ page: pagina || 1 }, this.filtro)
            const config = Object.assign({}, this.$store.getters.getHeaderAuth, { params })

            this.$axios.get(this.url('divergencias'), config).then(r => {
                this.divergencias = r.data
            }).catch(e => this.$store.commit('throwException', e)).finally(() => { this.carregandoDivergencias = false })
        },

        confirmarAcao (linha, acao) {
            const texto = {
                ACEITAR_SED: 'O SMGE vai ser atualizado com o que está na SED para esta escola (turmas, alunos e situação das matrículas). Nada é enviado à SED. Continuar?',
                ENCERRAR_NO_SMGE: 'A matrícula será encerrada como TRANSFERIDA apenas no SMGE — na SED o aluno já não está ativo nesta turma. Continuar?',
                USAR_FICHA_SED: 'Os campos diferentes serão copiados DA SED para a ficha do aluno no SMGE. Nada é enviado à SED. Continuar?',
                REENVIAR_FICHA_SMGE: 'A ficha do aluno no SMGE será ENVIADA à SED, substituindo os dados que estão lá. Continuar?'
            }[acao]

            this.$confirm(texto, 'Resolver divergência', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
                .then(() => this.resolver(linha, acao)).catch(() => {})
        },

        resolver (linha, acao) {
            this.resolvendo = linha.id
            this.$axios.post(this.url(`divergencias/${linha.id}/resolver`), { acao }, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data.throw) { window.eventBus.$emit('throw', r.data.throw); return }
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e)).finally(() => { this.resolvendo = null })
        },

        conciliar (escola) {
            this.conciliando = escola.id
            this.$axios.post(this.url(`conciliar/${escola.id}`), {}, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data.throw) { window.eventBus.$emit('throw', r.data.throw); return }
                window.eventBus.$emit('alert', { msg: `Comparação concluída: ${r.data.contadores.novas} divergência(s) nova(s).`, type: 'success' })
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e)).finally(() => { this.conciliando = null })
        },

        // ------------------------------------------------------------ configuração
        carregarConfiguracao () {
            this.$axios.get(this.url('configuracao'), this.$store.getters.getHeaderAuth).then(r => {
                if (r.data.throw) { window.eventBus.$emit('throw', r.data.throw); return }
                this.cfg = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },

        postCfg (caminho, corpo, aoConcluir) {
            this.$axios.post(this.url(caminho), corpo, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data.throw) { window.eventBus.$emit('throw', r.data.throw); this.carregarConfiguracao(); return }
                window.eventBus.$emit('alert', { msg: 'Configuração salva.', type: 'success' })
                if (aoConcluir) aoConcluir(r.data)
            }).catch(e => this.$store.commit('throwException', e))
        },

        habilitar (valor) {
            const texto = valor
                ? 'Ligar o envio à SED? As escolas marcadas como "Envia à SED" passam a gravar primeiro na SED a cada cadastro de turma, aluno e matrícula.'
                : 'Desligar o envio à SED? O SMGE volta a gravar só localmente; a comparação diária mostrará o que ficou sem enviar.'

            this.$confirm(texto, 'Integração SED', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
                .then(() => this.postCfg('configuracao/habilitar', { habilitada: valor }, () => { this.carregarConfiguracao(); this.carregar() })).catch(() => {})
        },

        salvarEscola (e) { this.postCfg('configuracao/escola/' + e.id, { codigo_sed: e.codigo_sed, sed_cod_unidade: e.sed_cod_unidade }) },

        salvarCurso (c) { this.postCfg('configuracao/curso/' + c.id, { sed_cod_tipo_ensino: c.sed_cod_tipo_ensino, sed_cod_serie_ano: c.sed_cod_serie_ano }) },

        buscarLog (pagina) {
            this.log.carregando = true
            const config = Object.assign({}, this.$store.getters.getHeaderAuth, { params: { page: pagina || 1, somente: this.log.somente, processo_id: this.log.processo_id } })

            this.$axios.get(this.url('requisicoes'), config).then(r => {
                if (!r.data.throw) this.log.dados = r.data
            }).catch(e => this.$store.commit('throwException', e)).finally(() => { this.log.carregando = false })
        },

        corPrioridade (p) { return p === 1 ? 'danger' : (p === 2 ? 'warning' : 'info') },

        rotuloStatus (s) {
            return { OK: 'concluída', ERRO: 'com erro', EM_ANDAMENTO: 'em andamento', EXECUCAO_SUSPEITA: 'suspeita — alguma escola foi pulada; avise o suporte' }[s] || s
        },

        descrever (d) {
            const x = d.detalhe || {}
            switch (d.tipo) {
                case 'ALUNO_FALECIDO_NA_SED':  return `${x.aluno} consta como FALECIDO na SED e está ativo no SMGE.`
                case 'ALUNO_DADOS_DIFERENTES': return `${x.aluno}: ` + (x.campos || []).map(c => (typeof c.sed !== 'undefined') ? `${this.rotuloCampo(c.campo)} — SMGE "${c.smge || '—'}" × SED "${c.sed}"` : `${this.rotuloCampo(c.campo)} diferente`).join('; ') + (x.alterada_na_sed_em ? ` (alterado na SED em ${x.alterada_na_sed_em}${x.operador ? ' por ' + x.operador : ''})` : '')
                case 'ALUNO_EM_OUTRA_ESCOLA':  return `${x.aluno} (${x.turma}) está ativo na SED em ${x.escola_sed || 'outra escola'}${x.municipio ? ' — ' + x.municipio : ''}${x.desde ? ', desde ' + x.desde : ''}.`
                case 'SITUACAO_DIFERENTE':     return `${x.aluno} (${x.turma}): na SED está "${x.sed_descricao}"; no SMGE, "${this.situacaoLocal(x.smge)}".`
                case 'CLASSE_DIFERENTE':       return `${x.aluno}: no SMGE está em ${x.turma_smge}; na SED, na classe ${x.classe_sed}.`
                case 'MATRICULA_SO_NO_SMGE':   return `${x.aluno} (${x.turma}) está ativo no SMGE, mas não consta na classe da SED.`
                case 'MATRICULA_SO_NA_SED':
                case 'ALUNO_SO_NA_SED':        return `${x.aluno} — RA ${x.ra} — está ativo na SED em ${x.turma} e não no SMGE.`
                case 'MATRICULA_SEM_VINCULO':  return `${x.aluno} (${x.turma}) não tem RA vinculado.`
                case 'TURMA_SO_NO_SMGE':       return `${x.turma} (classe ${x.classe}) não existe mais na SED.`
                case 'TURMA_SO_NA_SED':        return `Classe ${x.classe} (turma ${x.turma}, ${x.ativos} aluno(s)) existe na SED e não no SMGE.`
                case 'TURMA_SEM_VINCULO':      return `${x.turma} não tem classe correspondente na SED.`
                case 'TURMA_DADOS_DIFERENTES': return `${x.turma}: ` + (x.campos || []).map(c => `${c.campo} — SMGE ${c.smge || '—'} × SED ${c.sed || '—'}`).join('; ')
                case 'SED_INCONSISTENTE':      return `${x.turma}: a SED conta ${x.contador_classe} aluno(s), mas lista ${x.ativos_na_formacao}.`
                default:                       return JSON.stringify(x)
            }
        },

        rotuloCampo (c) {
            return { nome: 'Nome', mae: 'Mãe', pai: 'Pai', data_nascimento: 'Nascimento', sexo: 'Sexo', cor: 'Cor/raça', cpf: 'CPF', registro_nasc_novo: 'Certidão', logradouro: 'Logradouro', numero: 'Número', bairro: 'Bairro', cep: 'CEP', cidade_id: 'Cidade', nis: 'NIS', localizacao_zona: 'Zona', localizacao_diferenciada: 'Localização diferenciada', lat: 'Latitude', lng: 'Longitude' }[c] || c
        },

        situacaoLocal (s) {
            return { 1: 'Ativa', 2: 'Em transferência', 5: 'Cancelada', 7: 'Transferida', 9: 'Realocada', 10: 'Evadida', 11: 'Desistente', 12: 'Fechada' }[s] || s
        }
    }
}
</script>

<style scoped>
.sed-status { padding: 10px 14px; border-radius: 4px; margin-bottom: 14px; border-left: 4px solid #67c23a; background: #f0f9eb; }
.sed-status.erro { border-left-color: #f56c6c; background: #fef0f0; }
.sed-status i { font-size: 15px; margin-right: 5px; }
.sed-status .sep { margin: 0 8px; color: #c0c4cc; }
.sed-kpis { margin-bottom: 6px; }
.kpi { border: 1px solid #ebeef5; border-radius: 4px; padding: 10px; text-align: center; margin-bottom: 10px; background: #fff; }
.kpi .v { font-size: 22px; font-weight: bold; color: #303133; line-height: 1.2; }
.kpi .l { font-size: 11px; color: #909399; }
.kpi.alerta { border-color: #f56c6c; }
.kpi.alerta .v { color: #f56c6c; }
.sed-h { margin: 18px 0 8px; color: #303133; font-size: 14px; }
.sed-ultima { color: #606266; font-size: 12px; margin: 0 0 10px; }
</style>
